export default __webpack_public_path__ + "CircularCustCapNum-MediumItalic.cf435ee5f6d71892e50dcd9a24713ec6.woff";